module.exports = "<mat-dialog-content>\n  \t<div>\n    {{message}}\n    </div>\n \n</mat-dialog-content>\n\n<mat-dialog-actions>\n</mat-dialog-actions>\n"